import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

import type { TDadataFullNameSuggest } from 'shared/types/TDaData';
import { FullNameField } from 'shared/ui/FullNameField';

import type { TPassportFormFields } from 'entities/creditForm';

export const PersonFioField: FC<IFieldFactoryProps> = ({ ...props }) => {
  const { getValues, setValue } = useFormContext<TPassportFormFields>();

  const onInitialSuggestsLoad = useCallback(
    (option: Dictionaries.TSelectOption<string, TDadataFullNameSuggest['data']>) => {
      setValue('fullName', option, { shouldValidate: true });
    },
    [setValue],
  );

  return (
    <FullNameField
      {...props}
      initialFioValue={String(getValues('fullName')?.value || '')}
      onInitialSuggestsLoad={onInitialSuggestsLoad}
    />
  );
};
